<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('cdn.product')" class="mb-0">
							<el-select v-model="from.product" size="small" clearable :placeholder="$t('system.select')">
								<el-option v-for="item in agentData.product" :key="item.id" :label="item.name" :value="item.id" />
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('cdn.domain')" class="mb-0">
							<el-input v-model="from.domain" size="small" :placeholder="$t('system.select')" clearable></el-input>
						</el-form-item>
						<!-- <el-form-item label="AppName" class="mb-0">
							<el-input size="small" v-model="from.appname" clearable=""></el-input>
						</el-form-item>
						<el-form-item label="StreamName" class="mb-0">
							<el-input size="small" v-model="from.stream" clearable=""></el-input>
						</el-form-item> -->
						<!-- <el-form-item :label="$t('agentList.loginName')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item> -->
						
						
                     
						
						
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<!-- <el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button> -->
						</el-form-item>
				
					</el-form>
					<!-- <div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('agentList.add')}}</el-button>
					</div> -->
			</template>
		</div>
		
		<el-tabs  class="mt-3" v-model="type" @tab-click="handleClick" >
		     <el-tab-pane  :label="$t('monitoring.pullData')" name="1"></el-tab-pane>
		     <el-tab-pane  :label="$t('monitoring.pushData')" name="2"></el-tab-pane>
             <el-tab-pane  :label="$t('monitoring.pushSun')" name="3"></el-tab-pane>
             <el-tab-pane v-if="typeValue == 2" :label="$t('monitoring.hitRate')" name="4"></el-tab-pane>
             <el-tab-pane v-if="typeValue == 2" :label="$t('monitoring.httpCode')" name="5"></el-tab-pane>
             <el-tab-pane v-if="typeValue == 2" :label="$t('monitoring.httpCode2')" name="6"></el-tab-pane>
		    <!-- <el-tab-pane  :label="$t('monitoring.liveLog')" name="3"></el-tab-pane> -->
		</el-tabs>

		<!-- 表格 -->
		<div class="" style="padding-bottom:20px">
			<div style="display: flex; align-items: center;">
                <div style="display: flex; align-items: center; margin-right: 16px;">
                    <el-select v-model="from.granularity"  style="width: 120px" @change="changeGranularity">
                        <el-option :label="$t('monitoring.granularity_5min')" :value="1"></el-option>
                        <el-option :label="$t('monitoring.granularity_1hour')" :value="2"></el-option>
                    </el-select>
                </div>
                <div>
                    <el-tabs type="card"  class="mt-3" v-model="ac_type" @tab-click="handleClick" >
                    <el-tab-pane  :label="$t('monitoring.today')" name="1"></el-tab-pane>
                    <el-tab-pane  :label="$t('monitoring.zuo')" name="2"></el-tab-pane>
                    <el-tab-pane  :label="$t('monitoring.zuoqian')" name="3"></el-tab-pane>
                    <el-tab-pane  :label="$t('monitoring.qianzuo')" name="4"></el-tab-pane>
                    </el-tabs>
                </div>
                <div class="ml-2">
                    <el-date-picker
                    @change="changeTime"
                    v-model="from.time"
                    type="datetimerange"
                    :range-separator="$t('system.to')"
                    :start-placeholder="$t('system.startTime')"
                    :end-placeholder="$t('system.endTime')">
                    </el-date-picker>
                </div>
            </div>
		</div>
		<template v-if="type === '5' || type === '6'">
				<el-tabs v-model="from.httpCodeTab" @tab-click="onHttpCodeTabChange" style="margin-bottom: 10px;">
					<el-tab-pane label="4xx" name="4"></el-tab-pane>
					<el-tab-pane label="5xx" name="5"></el-tab-pane>
					<el-tab-pane label="3xx" name="3"></el-tab-pane>
					<el-tab-pane label="2xx" name="2"></el-tab-pane>
				</el-tabs>
			</template>
		<!-- 流量 -->
		<el-card
			v-if="eData.Flux.length > 0"
			class="box-card h_100 new_card"
			shadow="hover"
			>
			

			<div slot="header" class="clearfix">
				<span class="body_head">{{$t(getChartTitle(type, 'flux'))}}</span>
				<span v-if="type !== '5' && type !== '6'" class="ml-2" style="color: gray;">
					(<span v-if="fluxUnit">{{fluxUnit}}</span><span v-else>MB</span>)
				</span>
			</div>
			<div ref="myChart" style="height: 300px;"></div>
		</el-card>

		<!-- 带宽 -->
		<el-card
			v-if="eData.Bandwidth.length > 0 || eData.Bandwidth95.length > 0"
			class="box-card h_100 new_card mt-3"
			shadow="hover"
			>
		

			<div slot="header" class="clearfix">
				<span class="body_head">{{$t(getChartTitle(type, 'bandwidth'))}}</span>
				<span v-if="type !== '5' && type !== '6'" class="ml-2" style="color: gray;">
					( <span v-if="bandwidthUnit">{{bandwidthUnit}}</span><span v-else>Mbps</span>)
				</span>
			</div>
			

			<div ref="myChart2" style="height: 300px;"></div>
		</el-card>


			<!-- 如果两个都没有数据，显示空状态 -->
			<el-empty
			v-if="eData.Flux.length === 0 && eData.Bandwidth.length === 0 && eData.Bandwidth95.length === 0"
			:image-size="100"
			:description="$t('safe.none')"
			/>

			


		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('agentList.edit') : $t('agentList.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
                
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" :loading="layout.loading" :disabled="layout.loading" @click="submit">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	import echarts from 'echarts'
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				cloud_id:0,
				createModel: false,
				editIndex: -1,
				typeValue: 1,
				//搜索數据
				from: {
					product: '',
					domain: '',
					stream:'',
					appname:'',
					time:[],
					granularity: 1, // 默认5分钟
					httpCodeTab:'4'
				},
				auth_val: 'Agent',
				type:"1",
				ac_type:"1",
				fluxUnit: '', // 流量图单位
				bandwidthUnit: '', // 带宽图单位
				httpCodeTab: '4xx',

				preUrl: "data/monitoringList", //列表地址
				// delAllUrl: "user/delAdminAll", //批量删除地址
				delUrl: "user/delAgent", //删除單条地址
				addUrl: "user/addAgent", //添加/修改地址
				editStatusUrl:"user/editStatusAgent",//修改狀態地址
				
				tableData: [],
				form: {
                    name: "",
						username: '',
						password: '',
						password2: '',
						headUrl: '',
						tgQrUrl: '',
						tg_qr: '',
						icon:'',
						phone:'',
                        email:'',
                        tg_id:'',
                        share_code:'',
						status: 1,
						parent: 0,
						type: 1,
				},
				rules: {},
				eData:{
					date:[],
					Bandwidth:[],
					Flux:[],
					Flux95: [], // 添加95%流量数据
					Bandwidth95: [] // 添加95%带宽数据
				},
				agentData: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
			'from.product'(newVal) {
				const selectedProduct = this.agentData.product && Array.isArray(this.agentData.product)
					? this.agentData.product.find(item => item.id === newVal)
					: undefined;
				
				this.typeValue = selectedProduct ? selectedProduct.type : undefined;
				
				// 你可以在这里做后续逻辑
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['domain','product']);
		},
		methods: {
			// 计算95值（去掉最高和最低值）
			calculatePercentile(data, percentile = 95) {
				if (!Array.isArray(data) || data.length === 0) return [];
				
				// 去掉最高和最低值
				const sortedData = [...data].sort((a, b) => a - b);
				// 去掉最高和最低的5%数据
				const removeCount = Math.floor(sortedData.length * 0.05); // 去掉5%
				const filteredData = sortedData.slice(removeCount, sortedData.length - removeCount);
				
				// 如果过滤后数据不足，返回原始数据
				if (filteredData.length === 0) {
					const index = Math.ceil((percentile / 100) * sortedData.length) - 1;
					const percentileValue = sortedData[index];
					return data.map(() => percentileValue);
				}
				
				// 计算95%分位数
				const index = Math.ceil((percentile / 100) * filteredData.length) - 1;
				const percentileValue = filteredData[index];
				
				// 返回一个数组，每个元素都是95值值
				return data.map(() => percentileValue);
			},
			
			// 格式化数字显示 - 让大数字更易读
			formatNumber(num) {
				if (num === null || num === undefined) return '0';
				if (num === 0) return '0';
				
				const absNum = Math.abs(num);
				if (absNum < 1) return num.toFixed(3);
				if (absNum < 10) return num.toFixed(2);
				if (absNum < 100) return num.toFixed(1);
				return Math.round(num).toLocaleString();
			},
			
			// 转换95值的单位，确保与图表单位一致
			convertP95Value(value, fromUnit, toUnit) {
				if (!fromUnit || !toUnit || fromUnit === toUnit) {
					return value;
				}
				
				// 定义单位转换系数
				const unitFactors = {
					// 比特率单位
					'bps': 1,
					'kbps': 1000,
					'Mbps': 1000000,
					'Gbps': 1000000000,
					
					// 字节单位
					'B': 1,
					'KB': 1024,
					'MB': 1024 * 1024,
					'GB': 1024 * 1024 * 1024,
					'TB': 1024 * 1024 * 1024 * 1024,
					
					// QPS单位
					'QPS': 1,
					'kQPS': 1000,
					'MQPS': 1000000,
					'GQPS': 1000000000
				};
				
				const fromFactor = unitFactors[fromUnit];
				const toFactor = unitFactors[toUnit];
				
				if (fromFactor && toFactor) {
					// 单位转换：从大单位到小单位是乘以系数，从小单位到大单位是除以系数
					let convertedValue;
					
					if (fromFactor > toFactor) {
						// 从大单位转换到小单位（如 Mbps -> kbps）
						convertedValue = value * (fromFactor / toFactor);
					} else {
						// 从小单位转换到大单位（如 kbps -> Mbps）
						convertedValue = value / (toFactor / fromFactor);
					}
					
					return convertedValue;
				}
				
				return value;
			},
			
			// 智能单位换算 - 自动检测数据类型并选择合适的单位
			convertArrayToUnit(dataArray, unitType = 'auto') {
				if (!Array.isArray(dataArray) || dataArray.length === 0) {
					return { data: [], unit: '', originalData: dataArray };
				}
				
				// 自动检测数据类型
				if (unitType === 'auto') {
					const filteredData = dataArray.filter(val => val !== null && val !== undefined);
					
					if (filteredData.length === 0) {
						return { data: dataArray, unit: 'B', originalData: dataArray };
					}
					
					const maxValue = Math.max(...filteredData);
					
					// 改进的数据类型检测逻辑
					// 对于带宽数据，通常都是 bps 相关，不需要复杂的检测
					if (unitType === 'auto') {
						// 如果数据看起来像带宽数据（数值较大），直接使用 bitrate
						if (maxValue > 100) {
							unitType = 'bitrate';
						} else {
							unitType = 'qps';
						}
					}
				}
				
				let k, units, baseUnit;
				if (unitType === 'byte') {
					k = 1024;
					units = ['B', 'KB', 'MB', 'GB', 'TB'];
					baseUnit = 'B';
				} else if (unitType === 'bitrate') {
					k = 1000;
					units = ['bps', 'kbps', 'Mbps', 'Gbps'];
					baseUnit = 'bps';
				} else if (unitType === 'qps') {
					k = 1000;
					units = ['QPS', 'kQPS', 'MQPS', 'GQPS'];
					baseUnit = 'QPS';
				} else {
					// 默认按字节处理
					k = 1024;
					units = ['B', 'KB', 'MB', 'GB', 'TB'];
					baseUnit = 'B';
				}
				
				// 计算最佳单位
				const filteredData = dataArray.filter(val => val !== null && val !== undefined);
				if (filteredData.length === 0) {
					return { data: dataArray, unit: baseUnit, originalData: dataArray };
				}
				
				const maxValue = Math.max(...filteredData);
				if (maxValue === 0) {
					return { data: dataArray, unit: baseUnit, originalData: dataArray };
				}
				
				const i = Math.floor(Math.log(maxValue) / Math.log(k));
				const bestUnit = units[Math.min(i, units.length - 1)];
				const unitIndex = units.indexOf(bestUnit);
				
				// 转换数据
				const convertedData = dataArray.map(val => {
					if (val === null || val === undefined) return 0;
					return +(val / Math.pow(k, unitIndex)).toFixed(2);
				});
				
				return {
					data: convertedData,
					unit: bestUnit,
					originalData: dataArray
				};
			},
			// 获取最大单位
			getMaxUnit(dataArray, unitType = 'byte') {
				if (!Array.isArray(dataArray) || dataArray.length === 0) return '';
				
				const filteredData = dataArray.filter(val => val !== null && val !== undefined);
				if (filteredData.length === 0) return '';
				
				let k, units;
				if (unitType === 'byte') {
					k = 1024;
					units = ['B', 'KB', 'MB', 'GB', 'TB'];
				} else if (unitType === 'bitrate') {
					k = 1000;
					units = ['bps', 'kbps', 'Mbps', 'Gbps'];
				} else if (unitType === 'qps') {
					k = 1000;
					units = ['QPS', 'kQPS', 'MQPS', 'GQPS'];
				}
				
				const maxValue = Math.max(...filteredData);
				if (maxValue === 0) return units[0];
				
				const i = Math.floor(Math.log(maxValue) / Math.log(k));
				return units[Math.min(i, units.length - 1)] || units[0];
			},
			// 带宽速率算法
			getBandwidthArray(byteArray, intervalSeconds) {
				return byteArray.map(val => val ? (val * 8 / intervalSeconds) : 0);
			},
			// 智能图表数据处理 - 自动单位转换和格式化
			getChartData(type, raw, intervalSeconds = 300) {
				// 处理实际的数据结构：raw.traffic.data 和 raw.bandwidth.data
				const traffic = raw.traffic || { data: [], unit: '' };
				const bandwidth = raw.bandwidth || { data: [], unit: '' };
				
				// 提取数值数组 - 更灵活的数据提取
				let fluxArr = [];
				let bandwidthArr = [];
				
				// 尝试多种可能的数据结构
				if (traffic.data && Array.isArray(traffic.data)) {
					fluxArr = traffic.data.map(item => {
						if (typeof item === 'object' && item.value !== undefined) {
							return item.value;
						} else if (typeof item === 'number') {
							return item;
						}
						return 0;
					});
				} else if (Array.isArray(traffic)) {
					fluxArr = traffic.map(item => {
						if (typeof item === 'object' && item.value !== undefined) {
							return item.value;
						} else if (typeof item === 'number') {
							return item;
						}
						return 0;
					});
				}
				
				if (bandwidth.data && Array.isArray(bandwidth.data)) {
					bandwidthArr = bandwidth.data.map(item => {
						if (typeof item === 'object' && item.value !== undefined) {
							return item.value;
						} else if (typeof item === 'number') {
							return item;
						}
						return 0;
					});
				} else if (Array.isArray(bandwidth)) {
					bandwidthArr = bandwidth.map(item => {
						if (typeof item === 'object' && item.value !== undefined) {
							return item.value;
						} else if (typeof item === 'number') {
							return item;
						}
						return 0;
					});
				}
				
				// 计算95值
				const flux95Arr = this.calculatePercentile(fluxArr, 95);
				const bandwidth95Arr = this.calculatePercentile(bandwidthArr, 95);
				console.log('type',type);
				if (type == 1 || type == 2) {
					console.log('处理类型 1 或 2 - 流量和带宽数据');
					
					// 流量数据 - 自动检测单位类型
					const fluxResult = this.convertArrayToUnit(fluxArr, 'auto');
					const flux95Result = this.convertArrayToUnit(flux95Arr, 'auto');
					
					console.log('流量单位转换结果:', fluxResult);
					
					// 带宽数据 - 从流量计算得出
					// const bandwidthRaw = this.getBandwidthArray(fluxArr, intervalSeconds);
					// const bandwidth95Raw = this.getBandwidthArray(flux95Arr, intervalSeconds);
					const bandwidthResult = this.convertArrayToUnit(bandwidthArr, 'bitrate');
					const bandwidth95Result = this.convertArrayToUnit(bandwidth95Arr, 'bitrate');
					
					console.log('带宽单位:', bandwidthArr);
					console.log('带宽单位转换结果:', bandwidth95Result);
					
					const result = {
						flux: { data: fluxResult.data, unit: fluxResult.unit },
						flux95: { data: flux95Result.data, unit: flux95Result.unit },
						bandwidth: { data: bandwidthResult.data, unit: bandwidthResult.unit },
						bandwidth95: { data: bandwidth95Result.data, unit: bandwidth95Result.unit }
					};
					
					console.log('返回结果:', result);
					return result;
				} else if (type == 3) {

					
					// 请求数和QPS
					const fluxResult = this.convertArrayToUnit(fluxArr, 'auto');
					const flux95Result = this.convertArrayToUnit(flux95Arr, 'auto');
					
					// QPS计算
					const qpsArr = fluxArr.map(val => val / intervalSeconds);
					const qps95Arr = flux95Arr.map(val => val / intervalSeconds);
					const qpsResult = this.convertArrayToUnit(qpsArr, 'qps');
					const qps95Result = this.convertArrayToUnit(qps95Arr, 'qps');
					
					const result = {
						flux: { data: fluxResult.data, unit: fluxResult.unit },
						flux95: { data: flux95Result.data, unit: flux95Result.unit },
						bandwidth: { data: qpsResult.data, unit: qpsResult.unit },
						bandwidth95: { data: qps95Result.data, unit: qps95Result.unit }
					};
					
					console.log('返回结果:', result);
					return result;
				} else if (type == 4) {
					const flux95Data = this.calculatePercentile(fluxArr, 95);
					return {
						flux: { data: fluxArr, unit: '%' },
						flux95: { data: flux95Data, unit: '%' },
						bandwidth: { data: [], unit: '' },
						bandwidth95: { data: [], unit: '' }
					};
				} else if (type == 5 || type == 6) {
					const flux95Data = this.calculatePercentile(fluxArr, 95);
					return {
						flux: { data: fluxArr, unit: '' },
						flux95: { data: flux95Data, unit: '' },
						bandwidth: { data: [], unit: '' },
						bandwidth95: { data: [], unit: '' }
					};
				}
				
				// 兜底
				const fallbackResult = {
					flux: { data: [], unit: '' },
					flux95: { data: [], unit: '' },
					bandwidth: { data: [], unit: '' },
					bandwidth95: { data: [], unit: '' }
				};
				
				return fallbackResult;
			},
			getIntervalSeconds() {
				if (this.from.granularity == 1) return 300; // 5分钟
				if (this.from.granularity == 2) return 3600; // 1小时
				return 300; // 默认
			},
			
			changeTime(){
				this.ac_type = ''
				this.searchEvent()
				
			},
			changeGranularity() {
				// 调试颗粒度类型
				// console.log('颗粒度值', this.from.granularity, typeof this.from.granularity);
				this.from.granularity = Number(this.from.granularity); // 强制为数字
				this.searchEvent(); // 切换粒度时刷新数据
			},
			drawLine() {
				// console.log('drawLine', this.eData.Flux, this.fluxUnit);
				if (!this.$refs.myChart) {
					return false;
				}
				
				const myChart = echarts.init(this.$refs.myChart);
				myChart.clear(); 
				// 允许仅显示95线
				
				const xAxisData = this.eData.date;
				const seriesData = this.eData.Flux;
				const maxUnit = this.fluxUnit;
				
				myChart.setOption({
					color: ['#5470C6', '#FF0000'],
				
					tooltip: {
						trigger: 'axis',
						formatter: (params) => {
							let result = `${params[0].axisValue}<br/>`;
							params.forEach(param => {
								const name = param.seriesName || (param.seriesIndex === 0 ? '实际值' : '95值');
								const formattedValue = this.formatNumber(param.data);
								result += `${name}: ${formattedValue} ${maxUnit}<br/>`;
							});
							return result;
						}
					},
					legend: {
						show: true,
						data: ['实际值', '95值']
					},
					toolbox: {
						show: true,
						right: 20,
						feature: {
							dataView: { show: true, readOnly: false, title: this.$t('tool.data') },
							saveAsImage: { show: true, title: this.$t('tool.down_img') }
						}
					},
					grid: {
						left: '2%',
						right: '2%',
						bottom: '15%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: xAxisData,
						axisLabel: { formatter: val => val }, // 直接显示完整时间
						splitLine: { show: true, lineStyle: { type: 'dashed', color: '#eee' } }
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							formatter: `{value} ${maxUnit}`
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: '#eee'
							}
						}
					},
					dataZoom: [
						{
							type: 'slider',
							start: 0,
							end: 100,
							bottom: 5
						},
						{
							type: 'inside'
						}
					],
					series: [
						{
							name: '实际值',
							type: 'line',
							smooth: false,
							showSymbol: false,
							data: seriesData
						}
					]
				});
				
			},

			drawLine2() {
				// console.log('drawLine2', this.eData.Bandwidth, this.bandwidthUnit);
				if (!this.$refs.myChart2) {
					return;
				}
				const myChart = echarts.init(this.$refs.myChart2);
				myChart.clear(); 
				// 允许仅显示95线
				
				const xAxisData = this.eData.date;
				let seriesData = this.eData.Bandwidth;
				let series95Data = this.eData.Bandwidth95;
				// 保证 series 与 x 轴长度一致
				if (Array.isArray(series95Data) && series95Data.length && series95Data.length !== xAxisData.length) {
					series95Data = Array(xAxisData.length).fill(series95Data[0]);
				}
				const maxUnit = this.bandwidthUnit;
				
				myChart.setOption({
					color: ['#5470C6', '#FF0000'],
				
					tooltip: {
						trigger: 'axis',
						formatter: (params) => {
							let result = `${params[0].axisValue}<br/>`;
							params.forEach(param => {
								const formattedValue = this.formatNumber(param.data);
								result += `${param.seriesName || '实际值'}: ${formattedValue} ${maxUnit}<br/>`;
							});
							return result;
						}
					},
					legend: {
						show: true,
						data: ['实际值', '95值']
					},
					toolbox: {
						show: true,
						right: 20,
						feature: {
							dataView: { show: true, readOnly: false, title: this.$t('tool.data') },
							saveAsImage: { show: true, title: this.$t('tool.down_img') }
						}
					},
					grid: {
						left: '2%',
						right: '2%',
						bottom: '15%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: xAxisData,
						axisLabel: { formatter: val => val }, // 直接显示完整时间
						splitLine: { show: true, lineStyle: { type: 'dashed', color: '#eee' } }
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							formatter: `{value} ${maxUnit}`
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: '#eee'
							}
						}
					},
					dataZoom: [
						{
							type: 'slider',
							start: 0,
							end: 100,
							bottom: 5
						},
						{
							type: 'inside'
						}
					],
					series: [
						{
							name: '实际值',
							type: 'line',
							smooth: false,
							showSymbol: false,
							data: seriesData
						},
						{
							name: '95值',
							type: 'line',
							smooth: false,
							showSymbol: false,
							lineStyle: {
								type: 'dashed',
								color: '#FF0000'
							},
							data: series95Data
						}
					]
				});
				
			},
			getChartTitle(type, which) {
				// which: 'flux' 或 'bandwidth'
				const map = {
					1: { flux: 'monitoring.Flux', bandwidth: 'monitoring.Bandwidth' },
					2: { flux: 'monitoring.Bandwidth3', bandwidth: 'monitoring.Bandwidth4' },
					3: { flux: 'monitoring.Requests', bandwidth: 'monitoring.QPS' },
					4: { flux: 'monitoring.HitRate', bandwidth: '' },
					5: { flux: 'monitoring.HttpCodeOrigin', bandwidth: '' },
					6: { flux: 'monitoring.HttpCode', bandwidth: '' }
				};
				const t = map[Number(type)] || map[1];
				return t[which] || '';
			},

            
			//提交
			submit() {
				
				this.$refs.form.validate(res => {
					this.form.id = this.editIndex
					this.addOrEdit(this.form)
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(typeArr) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: typeArr,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.agentData = Object.assign({}, this.agentData, list);
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			
          
			
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(raw) {
				// 使用智能单位转换处理数据
				const chartData = this.getChartData(this.type, raw, this.getIntervalSeconds());
				
				// 假设 raw.traffic 和 raw.bandwidth 都有 data 和 unit 字段
				const traffic = raw.traffic || { data: [], unit: '' };
				const bandwidth = raw.bandwidth || { data: [], unit: '' };

				// x轴时间格式化，优先使用 traffic；若无则回退到 bandwidth 的时间
				let date = (traffic.data || []).map(item => {
					const d = new Date(item.time);
					const MM = (d.getMonth() + 1).toString().padStart(2, '0');
					const dd = d.getDate().toString().padStart(2, '0');
					const hh = d.getHours().toString().padStart(2, '0');
					const mm = d.getMinutes().toString().padStart(2, '0');
					return `${MM}-${dd} ${hh}:${mm}`;
				});
				if (!date.length && Array.isArray(bandwidth.data) && bandwidth.data.length) {
					date = bandwidth.data.map(item => {
						const d = new Date(item.time);
						const MM = (d.getMonth() + 1).toString().padStart(2, '0');
						const dd = d.getDate().toString().padStart(2, '0');
						const hh = d.getHours().toString().padStart(2, '0');
						const mm = d.getMinutes().toString().padStart(2, '0');
						return `${MM}-${dd} ${hh}:${mm}`;
					});
				}

				// 使用智能转换后的数据和单位
				this.fluxUnit = chartData.flux.unit || '';
				this.bandwidthUnit = chartData.bandwidth.unit || '';

				// 处理后端返回的带宽 p95（示例：{ p95: { raw: number, value: number, unit: 'Mbps' } }）
				let bandwidthP95Value = raw.p95 ? (typeof raw.p95 === 'object' ? raw.p95.value : raw.p95) : null;
				
				const xLen = date.length;
				const flux95 = []; // 流量不需要95线
				
				// 带宽95值处理 - 需要与图表单位保持一致
				let bandwidth95 = [];
				if (bandwidthP95Value != null) {
					console.log('95值处理:', { 
						originalValue: bandwidthP95Value,
						chartUnit: this.bandwidthUnit,
						note: '需要确保95值与图表单位一致'
					});
					
					// 如果95值需要单位转换，手动计算正确的转换
					let finalP95Value = bandwidthP95Value;
					if (this.bandwidthUnit && this.bandwidthUnit !== 'bps') {
						// 手动计算单位转换，避免 convertArrayToUnit 的复杂逻辑
						let convertedValue = bandwidthP95Value;
						
						if (this.bandwidthUnit === 'kbps') {
							convertedValue = bandwidthP95Value / 1024;
						} else if (this.bandwidthUnit === 'Mbps') {
							convertedValue = bandwidthP95Value / (1024 * 1024);
						} else if (this.bandwidthUnit === 'Gbps') {
							convertedValue = bandwidthP95Value / (1024 * 1024 * 1024);
						}
						
						finalP95Value = convertedValue;
						console.log('95值手动单位转换:', {
							original: bandwidthP95Value,
							converted: finalP95Value,
							fromUnit: 'bps',
							toUnit: this.bandwidthUnit,
							conversionFactor: this.bandwidthUnit === 'kbps' ? 1024 : this.bandwidthUnit === 'Mbps' ? (1024 * 1024) : this.bandwidthUnit === 'Gbps' ? (1024 * 1024 * 1024) : 1
						});
					}
					
					// 带宽95优先按带宽点位长度对齐，否则按 x 轴长度
					const bwLen = Array.isArray(bandwidth.data) ? bandwidth.data.length : xLen;
					bandwidth95 = Array(bwLen).fill(Number(finalP95Value));
				}

				// 备用方案：如果智能转换失败，使用原始数据
				const finalFlux = chartData.flux.data && chartData.flux.data.length > 0 ? chartData.flux.data : (traffic.data || []).map(item => item.value || item);
				const finalBandwidth = chartData.bandwidth.data && chartData.bandwidth.data.length > 0 ? chartData.bandwidth.data : (bandwidth.data || []).map(item => item.value || item);

				this.eData = {
					date: date,
					Flux: finalFlux,
					Flux95: flux95,
					Bandwidth: finalBandwidth,
					Bandwidth95: bandwidth95
				};
				
				console.log('95值处理结果:', {
					originalP95: raw.p95,
					finalP95Value: bandwidthP95Value,
					finalP95Array: bandwidth95,
					chartUnit: this.bandwidthUnit
				});
				this.$nextTick(() => {
					if (this.$refs.myChart) this.drawLine();
					if (this.$refs.myChart2) this.drawLine2();
				});
			},
			// 清空篩選條件
			clearSearch() {
				// 只重置必要字段，保留granularity
				this.from.product = '';
				this.from.domain = '';
				this.from.stream = '';
				this.from.appname = '';
				this.from.time = [];
				// 不重置granularity
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			},
			onHttpCodeTabChange() {
				this.searchEvent();
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
